module.exports = __webpack_public_path__ + "magnifier.8be2ed9c28d2c8749f0ee5756eb23780.svg";